
import * as MUTATION from '../mutationTypes'
import ajax from '../../http/ajax'
const state = {
    data_list: {},
    floor_list: {},
}

const mutations = {
    [MUTATION.GET_MARKETING_ACTIVITY_REQUEST] (state, res) {
    },
    [MUTATION.GET_MARKETING_ACTIVITY_SUCCESS] (state, res) {
        state.data_list = res
    },
    [MUTATION.GET_MARKETING_FLOOR_LIST_REQUEST] (state, res) {
    },
    [MUTATION.GET_MARKETING_FLOOR_LIST_SUCCESS] (state, res) {
        state.floor_list = res
    },
}

export const actions = {
    async getTopicDetail ({ commit }, params) {
        commit(MUTATION.GET_MARKETING_ACTIVITY_REQUEST)
        const res = await ajax.get('topicDetail', params)
        commit(MUTATION.GET_MARKETING_ACTIVITY_SUCCESS, res)
    },
    async getMarketingFloorList ({ commit }, params) {
        commit(MUTATION.GET_MARKETING_FLOOR_LIST_REQUEST)
        const res = await ajax.get('getFloorList', params)
        commit(MUTATION.GET_MARKETING_FLOOR_LIST_SUCCESS, res)
    },
}

export default {
    state,
    mutations,
}
